import React from 'react';
import './Servicos.css';

function Servicos() {
  const servicos = [
    {
      cargo: 'Terapia Ocupacional',
      descricao: 'Ajuda crianças a desenvolverem habilidades essenciais para o dia a dia, proporcionando mais independência, bem estar e inclusão.',
    },
    {
      cargo: 'Arteterapia',
      descricao: 'É um instrumento terapêutico para quem tem dificuldade em se expressar. Amplia as possibilidades de expressão, indo além da abordagem tradicional.',
    },
    {
      cargo: 'Orientação Familiar',
      descricao: 'A orientação familiar é um suporte dado às famílias que enfrentam desafios na criação dos filhos, promovendo escuta, acolhimento e estratégias para o dia a dia.',
    },
    {
      cargo: 'Orientação Educacional',
      descricao: 'Desenvolvimento de estratégias de aprendizagem, fortalecimento da autoestima dos estudantes e apoio à educadores na condução de suas turmas.',
    },
    {
      cargo: 'Psicopedagogia',
      descricao: 'Se o aprendizado tem sido um desafio, a psicopedagogia pode ser o caminho para transformar essa jornada em algo mais leve e prazeroso.',
    },
  ];

  return (
    <section className="servicos-section">
      <div className="servicos-card">
        <h2 className="section-title">Nossos Serviços</h2>
        <p className="servicos-description">
            Um pouco sobre cada serviço que oferecemos!
        </p>

        <div className="servicos-list">
          {servicos.map((item, index) => (
            <div className="servico-item" key={index}>
              <h3>{item.cargo}</h3>
              <p>{item.descricao}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Servicos;
